import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NX_MODAL_DATA} from "@allianz/ng-aquila/modal";
import {Partner} from "../../../models/partner.model";
import {PartnerService} from "../../../services/model/partner.service";
import {lastValueFrom} from "rxjs";
import {User} from "../../../models/user.model";

@Component({
    selector: 'app-add-partner-to-model',
    templateUrl: './add-partner-to-model.component.html',
    styleUrls: ['./add-partner-to-model.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddPartnerToModelComponent implements OnInit {
  modelPartners: Partner[];
  partners: Partner[] = [];
  selectedPartnerKeys: any[] = [];

  constructor(@Inject(NX_MODAL_DATA) public inputData: any, private partnerService: PartnerService) {
  }

  ngOnInit(): void {
    if (this.inputData.partners) {
      this.partners = this.inputData.partners;
      this.applyCurrentSelection();
    } else {
      this.loadData();
    }
  }

  private async loadData(): Promise<void> {
    this.partners = await lastValueFrom(this.partnerService.getAllByDeleted());
    this.applyCurrentSelection();
  }

  /**
   * Pre-select the partners that currently have this addon. Derived from the
   * `partners` options list (so the values are guaranteed to exist as options),
   * falling back to the partners passed with the addon row. The model assignment
   * is deferred so nx-multi-select has its `options` bound before the value is
   * written — it silently drops any selected value not present in `options` at
   * write time and never re-applies it afterwards.
   */
  private applyCurrentSelection(): void {
    const addonId = this.inputData.addon?.id;
    let current: Partner[] = this.inputData.addon?.partners;
    if (!current || current.length === 0) {
      current = this.partners.filter((p: any) =>
        (p.addons ?? []).map((a: any) => a?.addon?.id).includes(addonId));
    }
    this.modelPartners = [...(current ?? [])];
    setTimeout(() => {
      this.selectedPartnerKeys = this.modelPartners.map(p => p.id);
    });
  }

  getLabel() : (option: Partner) => string {
    return (option: Partner) => {
      return option.name
    };
  }

  partnerSelectionChange() {
    this.modelPartners = this.partners.filter(p => this.selectedPartnerKeys.includes(p.id));
  }
}
